<template>
    <dashboard-main-user v-if="$store.get('auth/role') === 'user'"></dashboard-main-user>
</template>

<script>
import DashboardMainUser from '@/components/dashboard/main/DashboardMainUser'

export default {
    components: {
        DashboardMainUser,
    }
}
</script>
